<template>
  <div ref="sewag" class="Sewag"></div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  data() {
    return {
      myChart: {},
    }
  },
  mounted() {
    this.myChart = echarts.init(this.$refs.sewag)
  },
  methods: {
    initChart(xdata = [], ydata = [], stand) {
      // initChart() {
      if (this.myChart) {
        this.myChart.clear()
      }
      let yMax = 0
      if (xdata.length > 0) {
        ;[yMax] = xdata
      }
      yMax = Math.max.apply(null, xdata)
      if (stand && yMax < stand) {
        yMax = stand * 1.2
      }
      let markLine
      if (stand) {
        markLine = {
          // 标准线
          symbol: 'none',
          symbolSize: 14,
          symbolOffset: [0, [0, -10]],
          silent: true,
          lineStyle: {
            color: '#FFD225',
            width: 2,
          },
          label: {
            color: '#FFD225',
            fontSize: 14,
          },
          data: [
            {
              yAxis: stand,
              label: {
                // position: 'insideEndBottom',
                formatter: '标准值',
              },
            }, // 最大值水平线或垂直线
          ],
        }
      }
      const option = {
        title: {
          show: false,
        },
        tooltip: {
          trigger: 'item',
        },
        grid: {
          top: '10px',
          left: '0%',
          right: '20%',
          bottom: '4%',
          containLabel: true,
        },
        xAxis: {
          name: '时间',
          data: ydata,
          nameTextStyle: {
            fontSize: 14,
          },
          boundaryGap: false,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#BAE7FF',
            },
          },

          axisLabel: {
            type: 'category',
            formatter: '{value}',
            rotate: 90,
            margin: 20,
            textStyle: {
              fontSize: 14,
              color: '#8EC0CE',
            },
          },
        },
        yAxis: {
          show: true,
          type: 'value',
          min: 0,
          max: yMax,
          splitLine: {
            show: true,
            lineStyle: {
              width: 2,
              dashOffset: 10,
              type: 'dashed',
              color: 'rgba(230, 247, 255, 0.2)',
            },
          },
          axisLabel: {
            formatter: '{value}',
            textStyle: {
              fontSize: 14,
              color: '#8EC0CE',
            },
          },
        },

        series: [
          {
            name: '',
            type: 'line',
            color: '#09CEA5',
            smooth: false, // 关键点，为true是不支持虚线，实线就用true
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 4,
                  type: 'dotted', // 'dotted'虚线 'solid'实线
                },
              },
            },
            lineWidth: 8,
            symbol: '',
            symbolSize: 12,
            markLine: markLine,
            data: xdata,
          },
        ],
      }
      this.$nextTick(() => {
        this.myChart.setOption(option)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.Sewag {
  width: 450px;
  height: 270px;
  margin: 0 auto;
}
</style>
